<form class="mce-form-section">

    <div class="mce-form-field-group">

        <div class="flex min-w-0 flex-grow flex-col">

            <div class="flex-grow" [class.mce-form-field-disabled]="primaryMethodsRx.isLoading()">
                <mat-form-field class="w-full">
                    <mat-label>primary method</mat-label>
                    <mat-select [formField]="form().installation.era6930P5Factors.primaryMethodGuid">
                        @for (option of primaryMethods(); track option.value) {
                        <mat-option [value]="option.value">{{option.label}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="flex-grow" [class.mce-form-field-disabled]="secondaryMethodsRx.isLoading()">
                <mat-form-field class="w-full">
                    <mat-label>secondary method</mat-label>
                    <mat-select [formField]="form().installation.era6930P5Factors.secondaryMethodGuid">
                        @for (option of secondaryMethods(); track option.value) {
                        <mat-option [value]="option.value">{{option.label}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

        </div>

        @if(viewState().hasInstallationImage){
        <div class="hidden sm:flex">
            <app-form-image [formImage]="viewState().installationImage"></app-form-image>
        </div>  }

    </div>

        <div class="mce-form-field-group">
            <app-grouping [form]="form().installation.era6930P5Factors.grouping"></app-grouping>
        </div>

        <div class="mce-form-field-group">

            @if(isBuried()) {
            <app-buried [form]="form().installation.era6930P5Factors.buried"></app-buried>
            }

            <app-ambient-temperature [form]="form().installation.era6930P5Factors.ambientTemperature" [isBuried]="isBuried()"></app-ambient-temperature>

        </div>


        <div class="mce-form-field-group">
            <app-user-defined-factor [form]="form().installation.era6930P5Factors.userDefinedFactor"></app-user-defined-factor>
        </div>



</form>
